import React from 'react';
import QRCode from 'qrcode';

import {Modal, ModalHeader, ModalBody} from 'Components/Modal';
import {Loading} from 'Components/Partials';

import RemoteConnections from 'Services/Api/MainStage/RemoteConnections';
import {Toast} from 'Services';

import {translation} from 'Services/TranslationHelpers';

export default class RemoteControlConnect extends React.Component {
    /**
     * @var timerInterval
     * @type {null}
     */
    timerInterval = null;

    /**
     * @var canvasRef
     * @type {HTMLCanvasElement}
     */
    canvasRef;

    state = {
        working: false,
        timeLeft: 30
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.fetchCode();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        window.clearInterval(this.timerInterval);
    };

    /**
     * @method fetchCode
     * @return {Promise<void>}
     */
    fetchCode = async () => {
        this.setState({working: true});

        const request = await RemoteConnections.get({
            session: this.props.sessionId
        });

        if (request.success) {
            const data = request.data.data;

            QRCode.toCanvas(this.canvasRef, data.url, (error) => {
                if (error) {
                    Toast.error();
                    return false;
                }
            });

            return this.setState({
                timeLeft: data.otp.expires,
                svg: null,
                working: false
            }, () => {
                this.timerInterval = setInterval(this.timer, 1000);
            });
        }

        Toast.error();
    };

    /**
     * @method timer
     */
    timer = () => {
        this.setState({
            timeLeft: this.state.timeLeft - 1
        }, () => {
            if (this.state.timeLeft === 0) {
                window.clearInterval(this.timerInterval);

                this.fetchCode();
            }
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {timeLeft, working} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    {translation('main_stage_frontend', 'connect_remote_control')}
                </ModalHeader>

                <ModalBody>
                    {working && (
                        <Loading/>
                    )}

                    <React.Fragment>
                        <div className="text-center">
                            <p className="mb-2">
                                {translation('main_stage_frontend', 'scan_qr_code')}
                            </p>

                            <p>
                                {translation(
                                    'main_stage_frontend',
                                    'code_expire',
                                    {'timeleft': timeLeft}
                                )}
                            </p>
                        </div>
                    </React.Fragment>

                    <canvas className="mx-auto" ref={ref => this.canvasRef = ref} />
                </ModalBody>
            </Modal>
        );
    }
}

